export default __webpack_public_path__ + "static/media/twitter.aff30da3.svg";